import { makeStyles } from '@map/theme';
import { HTMLAttributes } from 'react';
import { createPortal } from 'react-dom';

const useStyles = makeStyles(({ zIndex, palette }) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: zIndex.modal - 1,
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: palette.common.black,
    opacity: '0.3',
  },
}));

const ModalBackdrop: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const { classes, cx } = useStyles();
  return createPortal(
    <div {...props} className={cx(classes.root, props.className)} />,
    document.body,
  );
};

export default ModalBackdrop;
